export enum enumMarketingDocumentTypeCode {
    SalesOrder = 17,
    SalesInvoice = 13,
    SalesQutation = 23,
    SalesDeliveryNotes = 15,
    CreditNotes = 14,
    DebitNotes = 19,
    PurchaseRequest = 1470000113,
    GoodsReceipt = 59,
    GoodsIssue = 60,
    PurchaseInvoice = 18,
    PurchaseOrder = 22,
    PurchaseQutation = 540000006,
    GRPO = 20,
    APDownPaymentRequest = 204,
    ARDownPaymentRequest = 203,
    IncomingPayment = 24,
    OutgoingPayment = 46,
    ProfitAndLossReport = 50008,
    BUssinessPartnerReport = 50003,
    InventoryAuditReport = 50017,
    PurchaseQuotationCompariisonReport = 50009,
    TrialBalanceSheetReport = 50011,
    BalanceSheetReport = 50001,
    BillOfMaterialReport = 50002,
    GeneralLedgerReport = 50005,
    CustomerStatusReport = 50016,
    SalesOrderStatusReport = 50014,
    OpenItemList = 50006,
    OpenItemListForProduction = 50007,
    TransactionJournalReport = 50010,
    CheckRegisterReport = 50015,
    CustomerAndVendorAgingReport = 50004,
    SalesAnalysisReport = 50012,
    BPMasterReport = 50003

}
export enum enumPaginator {
    PageSize = 4,
};

export enum enumFormModes {
    ModeNew = 0,
    ModeEdit = 1,
    ModeAdd = 2,
    ModeUpdate = 3,
    ModeFind = 4,
    ModeView = 5,
    ModeOk = 6,
};

export enum enumMessageTypes {
    TypeNone = 0,
    TypeInformation = 1,
    TypeWarning = 2,
    TypeError = 3,

};

export enum enumDataTypes {
    TypeString = 1,
    TypeNumber = 2,
    TypeBoolean = 3,
    TypeDate = 4,
};

export enum enumLengths {

    TextLength100 = 100,
    TextLength200 = 200,
    TextLength300 = 300,
    TextLength400 = 400,
    TextLength500 = 500,
    TextLength20 = 20,

};

export enum enumBPMaster {
    Customer = 'C',
    Vendor = 'S',
    Lead = 'L'
};
export enum enumObjectType {
    Customer = 'customer',
    Vendor = 'vendor',
    Lead = 'lead',

};

export enum enumMarketingDocumentType {
    SalesOrder = 'salesorder',
    SalesInvoice = 'salesinvoice',
    SalesQutation = 'salesqutation',
    SalesDeliveryNotes = 'salesdelivery',
    CreditNotes = 'creditnotes',
    DebitNotes = 'debitNotes',
    PurchaseRequest = 'purchaserequest',
    GoodsReceipt = 'goodsreceipt',
    GoodsIssue = 'goodsissue',
    PurchaseOrder = 'purchaseorder',
    PurchaseQutation = 'purchasequtation',
    PurchaseInvoice = 'purchaseinvoice',
    GRPO = 'GRPO',
    APDownPaymentRequest = 'APDownPaymentRequest',
    ARDownPaymentRequest = 'ARDownPaymentRequest',
    DeleveryChalan = 'deliveryChalan',
    // DebitNotes='debitNotes',
    // CreditNotes='creditNotes'
    PickLists = 'picklists'
};
export enum enumGeneralSetting {
    GeneralSetting = 'generalsetting',
    Attachment = 'attachment',
    Inventory = 'inventory',
    SalesPurchase = 'sales/purchase'
}

export enum enumMarketingDocumentList {
    SalesOrderList = 'salesOrderListView',
    SalesInvoiceList = 'salesInvoiceListView',
    SalesQutationList = 'salesQutationListView',
    SalesDeliveryNotesList = 'salesDeliveryNotesNotesListView',
    CreditNotesList = 'creditNotesListView',
    PurchaseOrderList = 'purchaseOrderListView',
    PurchaseRequestList = 'purchaseRequestListView',
    PurchaseInvoiceList = 'purchaseInvoiceListView',
    PurchaseQutationList = 'purchaseQutationListView',
    APDownPaymentRequestList = 'purchaseDownPaymentRequestListView',
    ARDownPaymentRequestList = 'salesDownPaymentRequestListView',

    GRPOList = 'GRPOListView',
    DeleveryChalanList = 'deleveryChalanListView',
    DebitNotes = 'debitNotesListView',
    CreditNotes = 'creditNotesListView',
    PickLists = "pickListsListView"
};

export enum enumMarketingDocumentEntryForm {
    SalesOrderEntry = 'salesOrderEntryForm',
    SalesQutationEntry = 'salesQutationEntryForm',
    SalesInvioceEntry = 'salesInvoiceEntryForm',
    PurchaseRequestEntry = 'purchaseRequestEntryForm',
    PurchaseOrderEntry = 'purchaseOrderEntryForm',
    PurchaseQutationEntry = 'purchaseQutationEntryForm',
    DeliveryChallansEntry = 'deliveryChallanEntryForm',
    ARDownPaymentRequestEntry = 'salesDownPaymentRequestEntryForm',
    GRPOEntryForm = 'GRPOEntryForm',
    APDownPaymentRequest = 'purchaseDownPaymentRequestentryform',
    CreditNoteEntry = 'creditNotesEntryForm',
    DebitNoteEntry = 'debitNotesEntryForm',
    PurchaseInvoiceEntry = 'purchaseInvoiceEntryForm',
    PickListsEntry = 'pickListsEntryForm'
};
export enum enumGeneralSettingEntryForm {
    GeneralSetting = 'generalsetting',
    Attachment = 'attachment',
    Inventory = 'inventory',
    SalesPurchase = 'sales/purchase'
}
export enum enumGoodsIssueReceiptDocumentType {
    GoodsIssue = 'goodsissue',
    GoodsReceipt = 'goodsreceipt'
}
export enum enumGoodsIssueReceiptDocumentList {
    GoodsIssueList = 'goodsIssueListView',
    GoodsReceiptList = 'goodsReceiptListView'
}
export enum enumIncomingOutgoingPaymentDocumentType {
    IncomingPayment = 'incomingpayment',
    OutgoingPayment = 'outgoingpayment'
}
export enum enumIncomingOutgoingPaymentDocumentList {
    IncomingPaymentList = 'incomingPaymentListView',
    OutgoingPaymentList = 'outgoingPaymentListView'
}
export enum enumMarketingEntryForm {
    SalesOrder = 'salesorder',
    SalesInvoice = 'salesinvoice',
    SalesQutation = 'salesqutation',
    PurchaseOrder = 'purchaseorder',
    PurchaseRequest = 'purchaserequest',
    GoodsReceipt = 'goodsreceipt',
    GoodsIssue = 'goodsissue',
    PurchaseQutation = 'purchasequtation',
    PurchaseInvoice = 'purchaseinvoice',
    GRPO = 'GRPO',
    APDownPaymentRequest = 'APDownPaymentRequest',
    DeliveryChallans = 'deliverychallans',
    ARDownPaymentRequest = 'ARDownPaymentRequest',
    CreditNotes = 'creditNotes',
    DebitNotes = 'debitNotes',

};
export enum enumErrorMessageText {
    requesterStatus = 'Please Define Requester',
    UserCodeStatus = 'Please Define User Code',
    UserNameStatus = 'Please Define User Name',
    DepartmentStatus = 'Please Select Department',
    periodStatusName = 'Please Define Period Status',
    DateFormat = 'Date is accepted only in MM/DD/YYYY',
    ProjectCodeStatus = 'Please Define Project Code.',
    ProjectNameStatus = 'Please Define Project Name.',
    CompetitorsNameStatus = 'Please Define the Name',
    PartnerNameStatus = 'Please Define the Name',
    DescriptionStatus = 'Please Define Description',
    RelationshipDescriptionStatus = 'Please Define Relationship Description',
    OpportunitycardCodeStatus = 'Please Select the Customer Code',
    OpportunitycustomerNameStatus = 'Please Select the Customer Name',
    OpportunitypredictedClosingDateStatus = 'Please Define Predicted Closing Date',
    OpportunitypotentialAmountStatus = 'In Potential Amount Field, enter number greater then 0',
    OpportunitystartDateStatus = 'Please Define Start Date',
    OpportunityclosingDateStatus = 'Please Define Closing Date',
    OpportunitystageKeyNameStatus = 'Please Select stage in',
    OpportunityclosingDataStatus = "Please Define Closing Date",
    ActivitycardCodeStatus = 'Please Select the Customer/Vendor/Lead Code',
    ActivitycardNameStatus = 'Please Select the Customer/Vendor/Lead Name',
    ActivitystartDateStatus = 'Please Define Start Date',
    ActivitystartTimeStatus = 'Please Define Start Time',
    ActivityendDueDateStatus = 'Please Define End Date',
    ActivityendTimeStatus = 'Please Define End Time',
    ActivitydurationDescriptionStatus = 'Please mention Duration',
    CopmanyNameStatus = 'Please Define Company Name',
    CountryNameStatus = 'Please Select Country.',
    StateNameStatus = 'Please Select State.',
    BankCountyNameStatus = 'Please Select Bank Country',
    BankAccountStatus = 'Please Select Bank Name',
    BranchBankStatus = 'Please Define Bank Branch',
    AccountNumberStatus = 'Please Define Account No. in House Bank Master',
    BPLStatus = 'Please Define Branch Name.',
    LocationStatus = 'Please Define Location Name.',
    StateStatus = 'Please Define State.',
    CountryStatus = 'Please Define Country.',
    GSTNumber = 'Please Define GST No.',
    GSTTypeName = 'Please Select GST Type.',
    PanNumber = 'Please Define PAN No.',
    itemCodeStatus = 'Please Define Item No.',
    paymentTermsStatus = 'Please Define Payment Terms.',
    itemNameStatus = 'Please Define Item Description',
    BatchbatchNumberStatus = 'Please Define Batch Number',
    SerialNoStatus = 'Please Define Serial No.',
    GroupNamestatus = 'Please Select Item Group Master',
    itemchapterIDStatus = 'Please Define HSN',
    itemsacEntrytatus = 'Please Define SAC',
    itemgstTaxCategoryNameStatus = 'Please Define Tax Category',
    itemmanageSerialAndBatchNumbersNamestatus = 'Please Define Manage Item By',
    ItemgroupNameStatus = 'Please Define Item Group Name',
    ItemClassStatus = 'Please Select Group Category',
    fromWarehouseStatus = 'Please Select From Warehouse',
    toWarehouseStatus = 'Please Select To Warehouse',
    taxDateStatus = 'Please Define Document Date',
    docDateStatus = 'Please Define Posting Date',
    docEntryStatus = 'Please specify a number greater then 0.',
    quantityStatus = 'Quantity must be greater then 0.',
    fromWarehouseCodeStatus = 'Please Select from Warehouse for Item Code line No.1',
    warehouseCodeStatus = 'Please Select Warehouse',
    postingDateStatus = 'Please Define Posting Date',
    countDateStatus = 'Please Define Count Date',
    deliveryDateStatus = 'Please Define Delivery Date',
    countTimeStatus = 'Please Define Count Time',
    branchNameStatus = 'Please specify an active Branch[Inventory Posting- Branch]',
    InventoryitemCodeStatus = 'Please specify an Item No.',
    InventoryitemNameStatus = 'Please specify an Item Description',
    warehouseNameStatus = 'Please Define Warehouse for Item Code line 1',
    initialNumberStatus = 'Please Define From No.',
    nextNumberStatus = 'Please Define Next No.',
    periodIndicatordocStatus = 'Please Define Period.',
    bplidNameStatus = 'Please Define Branch',
    seriesNameStatus = 'Please Define Series Name',
    OriginalRefDate = 'Please Select Orignal Refrence Date',
    OriginalRefNo = 'Please Enter Orignal Refrence Number',
    docNumStatus = 'Please Specify a number greater than 0',
    cardCodeStatus = 'Please Select Card Code',
    bplNameStatus = 'Please Select an Active Branch',
    cardNameStatus = 'Please Select the Card Name',
    groupNameStatus = 'Please Define Group',
    currencyNameStatus = 'Please Define Currency',
    businessTypeNameStatus = 'Please Define Business Partner Type',
    contactEmployeesStatus = 'Please Define Contact ID',
    bpAddressesStatus = 'Please Define Address Name (Bill To)',
    bpAddressesStatus1 = 'Please Define Address Name (Ship To)',
    stateNameStatus = 'Please Select State.',
    gstTypeNameStatus = 'Please Select GST Type',
    gstinStatus = 'Please Define GST No',
    documentStatusNameStatus = 'Please Define Document Status',
    accountNameStatus = 'Please Define Account Code [Good Issue -Rows-Account Code]',
    treeCodeStatus = 'Please Define Product No.',
    productDescriptionStatus = 'Please Define Product Description',
    warehouseStatus = 'Please Define Warehouse',
    ProductQuantityStatus = 'Please Define Quantity',
    issueMethodStatus = 'Please Define Issue Method',
    baseRefStatus = 'Please specify an Order No.',
    plannedQuantityStatus = 'In Planned Quantity field please enter value greater then 0.[Production Order- Planned Quantity]',
    ProductionwarehouseNameStatus = 'Please Define Warehouse for Final Product',
    ProductionpostingDateStatus = 'Please Define Order Date',
    ProductionstartDateStatus = 'Please Define Start Date',
    ProductiondueDateStatus = 'Please Define the Due Date',
    AccountcodeStatus = 'Please Define Account Code',
    AcctCurrencyStatus = 'Please Define Currency',
    AcctLevelStatus = 'Please Define Account Level',
    AccountTypeStatus = 'Please Define Account type.',
    FatherAccountStatus = 'Please Define Parent Account Name.',
    CostcenterCodeStatus = 'Please Define Cost Center Code',
    DimensionStatus = 'Please Define Dimension',
    ActiveDateStatus = 'Please Define Active From Date',
    CurrencyCodeStatus = 'Please Define Currency Code',
    InterNationCodeStatus = 'Please Define International Code',
    SalesEmpStatus = 'Please Define Sales Employee Name',
    billquantitystatus = 'Please Define Quantity for Item Code',
    billwarehousestatus = 'Please Define Warehouse for Item Code',
    itemquantityStatus = 'In Qty(Quantity) Coloumn Please enter value greater then 0',
    itemwarehouseStatus = 'Please Define Warehouse',
    ProductionitemCodeStatus = 'Please Select Product No.',
    ProductionitemNameStatus = 'Please Specify an Item Description',
    productionplannedQuantityStatus = 'In Planned Quantity field please enter value greater then 0[Production Order]-Planned Quantity',
    ProductionitemNoStatus = 'Please Specify an Item No.',
    productiontabplannedQuantityStatus = 'In Planned quantity column, please enter value greater then 0',
    productiontabwareHouseNameStatus = 'Please Define Wraehouse for Item Code',
    productiontabwipAccountNameStatus = 'Please Define WIP Account Code for Item Code',
    productiontablocationCodeNameStatus = 'Please Define Location In Warehouse',
    warehuseDefaultStatus = 'While creation a new Branch Please Select Default Warehouse Which is not assigned to any branch.',
    customerGroup = 'Please Define Group Name',
    vendorGroup = 'Please Define Group Name',
    empFirstName = 'Please Define First Name',
    empLastName = 'Please Define Last Name',
    paymentTermStatus = 'Please Define Payment Term.',
    warehouseMasterStatus = 'Please Define Warehouse Code',
    locationStatus = 'Please Define Location',
    branchStatus = 'Please Define Branch',
    departmentStatus = 'Please Define Department Name.',
    designationStatus = 'Please Define Designation Name.',
    houseBankStatus = 'Please Select Bank Code',
    accountNum = 'Please Define Account Number',
    itemCode = 'Please Select Item',
    ifscCode = 'Please Define IFSC Code',
    payTermsGrpCodeNameStatus = 'Please DefinePayment Terms',
    taxId0Status = 'Please Define Pan No',
    transporterCodeStatus = 'Please Select Transporter Code',
    transporterIDStatus = 'Please Define Transporter ID',
    transporterNameStatus = "Please Select Transporter Name",
    docDueDateStatus = 'Please Define Expected Delivery Date',
    hsnDescriptionStatus = 'Please select HSN/SAC since GST tax Code is selected',
    taxCodeStatus = 'Please Select Tax Code',
    periodindicatorStatus = 'Please Define PeriodIndicator',
    numberOfPeriodsStatus = 'Please Define Number of Period',

    defaultCustomerPaymentTermsNameStatus = 'Please Define Default Payment Term for Customer',
    defaultVendorPaymentTermsNameStatus = 'Define Default Payment Term for Vendor',
    attachmentsFolderPathStatus = 'Please Define Attachment Path',
    picturesFolderPathStatus = 'Please Define Pictures Folder',
    defaultWarehouseNameStatus = 'Please Define Default Warehouse',
    periodCatStatus = 'Please Define Period Selection',
    userCodeStatus = 'Please Define User Code',
    userNameStatus = 'Please Define User Name',
    userEmailStatus = 'Please Define Email',
    periodCodeStatus = "Please Define Period Code",
    periodNameStatus = "Please Define Period Name",
    subPeriodTypeStatus = "Please Define Sub-Periods",
    periodIndicatorStatus = "Please Define Period Indicator",
    periodStatus = "Please Define Period Status",

    PostingDateFromStaus = "Please Define From Posting Date",
    PostingDateToStaus = "Please Define To Posting Date",
    DueDateFromStatus = "Please Define From Due Date",
    DueDateToStatus = "Please Define To Due Date",
    DocumentDateFromStatus = "Please Define From Document Date",
    DocumentDateToStatus = "Please Define To Document Date",
    beginningofFinancialYearStatus = "Please Define Start of Fiscal Year",
    yearStatus = "Please Define a Fiscal Year",
    StageStatus = 'Please Define the Name',
    StageNoStatus = 'Please Define Stage Number',
    ClosingPercentageStatus = 'Please Define Closing Percentage',
    CreditCardNameStatus = 'Please Define Credit Card name',
    GlAccountStatus = 'Please Define G/L Account',
    BaselineDateStatus = 'Please Define Due Date Based on',
    genderStatus = 'Please Select Gender',
    WorkCountryStatus = 'Please Define Work Country.',
    HomeCountryStatus = 'Please Define Home Country.',
    HomeStateStatus = 'Please Define Home State.',
    WorkStateStatus = 'Please Define Work State.',
    stageNameStatus = 'Please Define Name',
    seqNumStatus = 'Please Define Stage Number',
    seriesStatus = 'To Generate This Document,First Define The Numbering Series in the Setting Module Document Numbering',
    documentStatus = 'Please Define Status',
    skuStatus = 'Please Define Status',
    quantityGoodIssueStatus = 'In "Qty" (Quantity) column, please enter value greater than 0',
    branchNameWarehouseStatus = 'Please Define Branch in warehouse',
    branchNameGoodReceiptStatus = 'Please Specify an active branch [Goods Receipt - Branch]',
    warehouseGoodReceiptStatus = "Please Define warehouse for 'Item Code'",
    accountNameGoodReceiptStatus = 'Please Define Account Code',
    componentEmptyStatus = 'Please Define Component',
    DrawerEmptyStatus = 'Please Define Title/Drawer.',
    series = 'To Generate This Document First Define The Numbering Series In The Setting Module ',
    PriceListNameStatus = 'Please Define Price List Name',
    itemGroupNameStatus = 'Please Define Item Group Name',
    warehouseNameStatus2 = 'Please Define Warehouse Name',
    branchNameStatus2 = 'Please Define Branch Name',
    unitStatus2 = 'Please Define Unit',
    valuationMethodStatus2 = 'Please Define Valuation Method',
    ReferenceDateEmptyStatus = 'Please Specify Posting Date',
    DueDateEmptyStatus = 'Please Specify Due Date',
    TaxDateEmptyStatus = 'Please Specify Document Date',
    BranchNameEmptyStatus = 'Please Specify an active branch',
    DebitCreditEmptyStatus = 'Enter amount in "Debit" and "Credit" columns',
    AccountCodeEmptyStatus = 'Please Specify G/L Account / Customer / Vendor code',
    SeriesEmptyStatus = 'To Generate This Document,First Define The Numbering Series in the Setting Module Document Numbering',
    CustomerVendorCode = 'Please Select the Customer/Vendor code',
    AddressEmptyStatus = 'Please Select Pay to / Bill to address',
    companyDbNameStatus = 'Please Define Company DB Name',
    companyNameStatus = 'Please Define Company Name ',
    PaymentNegative = 'Please Define Payment greater than 0 ',
    transType = 'Please Choose Trans Type',
    oderStatus = 'Please Choose Order Status'
};
export enum enumTransactionType {
    SalesInvoice = 13,
    SalesQutation = 23,
    SalesDeliveryNotes = 15,
    CreditNotes = 14,
    DebitNotes = 19,
    PurchaseOrder = 22,
    GRPO = 20,
    PurchaseDownPaymentRequest = 204,
    IncomingPayment = 24,
    OutgoingPayment = 46,
    JournalEntry = 30
}
export enum enummaxLengthMessageError {
    codeLength = 'Please give Max Length in Project Code only 20 Char'
}
export enum apiServiceMessageError {
    tableAlreadyExisted = 'This entry already exists in the following tables (ODBC -2035)',
    branhcMasterError = '1320000271 - Select a warehouse not assigned to any other branches [OBPL.DflWhs][line: 0]',
    panNumberStatus = 'PAN number cannot be duplicated [Location - PAN Number]  [Message 2001111111-11]',
    activityInactiveError = 'Customer/Vendor is inactive, please Select Active Customer/Vendor',
    PeriodIndicatorStatus = 'This entry already exists in the following tables "Period Indicator" (OPID) (ODBC -2035)',
    headerRowLevelWarehouseDifferentStatus = 'Header level warehouse location is different from line level warehouse location [Inventory Transfer - Rows - Location Code][line: 1]  [Message 439-261]',
    fromToWarehouseSameStatus = 'Receipt warehouse cannot be identical to the release warehouse',
    seriesStatus = 'To Generate This Document, First Define the Numbering Series in the Administration',
    documnetnumbering = 'Series Primary overlaps object Sales Orders',
    itemmaster = 'Cannot change Code of an item that is a component of another item  [Message 150-12]',
    salesstages = 'Stage number already exists.  [OOST.StepId]',
    itemGroupError = " [OITB.IUoMEntry] , 'This entry already exists in the following tables (ODBC -2035)'"

}
export enum customeErrorMessage {
    userMasterError = 'User Code already available, Please Define Unique User Code.',
    locationMasterError = 'Location already available, Please Define Unique Location.',
    currencySetupError = 'Currency Code already available, Please Define Unique Currency Code',
    projectMasterError = 'Project Code already available, Please Define Unique Project Code',
    branhcMasterError1 = 'Please Select a warehouse which is assigned to this branch',
    customerGrp = 'Group Name already available, Please Define Unique Group Name',
    vendorGrp = 'Group Name already available, Please Define Unique Group Name',
    currencyError = 'Currency Code already available, Please Define Unique Currency Code.',
    salesEmpError = 'Sales Employee Name already available, Please Define Unique Sales Employee Name',
    paymentTermErr = 'Payment Term already available, Please Define Unique Payment Term.',
    CompetitorsNameError = 'Name already available, Please Define Unique Name',
    RelationshipMasterNameError = 'Name already available, Please Define Unique Description',
    ChartOfAccountError = 'Account Code already avilable, Please Define Unique Account Code',
    CostCenterError = 'Cost Center Code already avilable, Please Define Unique Cost Center Code',
    warehouseMasterError = 'Warehouse Code already available, Please Define Unique Warehouse Code',
    departmentMasterError = 'Department Name already available, Please Define Unique Department Name',
    houseBankMasterError = 'Account Number already available, Please Define Unique Account Number',
    // userCodeStatusError='User Code already available , Please Define Unique User Code'
    stageMasterError = 'Name already available, Please Define Unique Name',
    creditCardError = 'Credit Card Name already available, Please Define Unique Credit Card Name',
    PartnersError = 'Name already available, Please Define Unique Name',
    documentNumberingError = 'Define Series name already in available, Please Define Unique Series Name',
    panNumberError = 'PAN number cannot be duplicated',
    periodIndicatorMasterError = 'Period Indicator already available, Please Define Unique Period Indicator',
    documentNumberingSeriesOverlap = 'New1 (Start Number) from number overlaps (as per document)',
    TranspoterMasterError = 'Transporter ID already available, Please Define Unique Transporter ID',
    InventoryCountingError = 'To genertate this Document First Define The numbering Series In The Setting Module DocumentNumbering',
    //documentNumberingError = 'Define Series name already avilable, Please Define Unique Series Name'
    periodIndicatorError = 'Header level warehouse location is different from line level warehouse location',
    quantityError = "Selected warehouse, Quantity not available  for 'Item Code' line No. 1",
    fromToWarehouseSameError = "From warehouse and To warehouse cannot Same",
    // seriesError = 'To generate this document,first assigned branch to loging User',
    itemMasterError = 'You cannot change the inventory item category; item has been used in one or more transactions',
    seriesError = 'To generate this document, first assigned branch to loging User',
    salesStagesError = 'Stage Number already avaliable , Please Define Unique Stage Number',
    itemGroupError = 'Item Group Name already available ,Please Define Unique Item Group Name'
}


export enum enumGoodsIssueEntryForm {
    GoodsIssueEntry = 'goodsIssueEntryForm',
    GoodsReceiptEntry = 'goodsReceiptEntryForm'

}
export enum enumIncomingOutgoingPaymentEntryForm {
    IncomingPaymentEntry = 'incomingPaymentEntryForm',
    OutgoingPaymentEntry = 'outgoingPaymentEntryForm'

}
